<ng-container *ngIf='documentEditorDetails'>
  <div class='latest-change mb-2 pb-2'>
    <div class='d-flex flex-column w-100'>
      <div>{{ 'LABELS.LAST_CHANGE' | translate }}</div>
      <div>{{ chapterInfo?.lastUpdatedAt | latestChangeDate }}</div>
    </div>
    <div class='d-flex flex-column'>
      <div class="d-flex " style="height: 25px;">

        <pt-editor-sidebar-preview-btn
          (preview)="preview.emit()"
          [disabled]="previewLoading"
          [loading]="previewLoading">
        </pt-editor-sidebar-preview-btn>

        <pt-editor-sidebar-download-word-btn
          style="margin-left: 4px;"
          (downloadWord)="downloadWord.emit()"
          [disabled]="wordLoading"
          [loading]="wordLoading">
        </pt-editor-sidebar-download-word-btn>

        <pt-editor-sidebar-menu-btn
          (documentActionEvent)="documentActionEvent.emit($event)"
          [disabled]="previewLoading"
          [documentInfo]="documentInfo"
          [loading]="previewLoading"
          [availableOperations]="documentPermission"
          class='ms-1'>
        </pt-editor-sidebar-menu-btn>
      </div>

      <pt-treatment-action-state
        [completed]='documentEditorDetails.completed'
        [noCompletedMessage]='"MESSAGE.DOCUMENT_NO_COMPLETED" | translate'
        [status]='documentEditorDetails.status'
        class='ms-1'
      ></pt-treatment-action-state>
    </div>
  </div>

  <pt-editor-sidebar-text
    (clickCancel)='resetField(EditorEditItem.NAME)'
    (clickEdit)='editField(EditorEditItem.NAME)'
    (clickSave)='saveField(EditorEditItem.NAME, $event)'
    *ngIf='nameButton'
    [editorButton]='nameButton'
    [label]="'LABELS.NAME' | translate"
    [maxLength]="128"
    [value]='documentEditorDetails.name'>
  </pt-editor-sidebar-text>

  <pt-editor-sidebar-text
    (clickCancel)='resetField(EditorEditItem.INTERNAL_ID)'
    (clickEdit)='editField(EditorEditItem.INTERNAL_ID)'
    (clickSave)='saveField(EditorEditItem.INTERNAL_ID, $event)'
    *ngIf='internalIdButton'
    [editorButton]='internalIdButton'
    [label]="'LABELS.INTERNAL_ID' | translate"
    [value]='documentEditorDetails.internalId'>
  </pt-editor-sidebar-text>

  <pt-editor-sidebar-navigation-data
    (clickCancel)='resetField(EditorEditItem.LEGAL_ENTITY)'
    (clickEdit)='editField(EditorEditItem.LEGAL_ENTITY)'
    (clickSave)='saveField(EditorEditItem.LEGAL_ENTITY, $event)'
    *ngIf='legalEntityButton && legalEntitiesNavigationData'
    [dataLabel]='legalEntitySelectLabel'
    [data]='legalEntitiesNavigationData'
    [editorButton]='legalEntityButton'
    [label]='legalEntityLabel'
    [optional]='false'
    [value]='legalEntityId'>
  </pt-editor-sidebar-navigation-data>

  <pt-editor-sidebar-navigation-data
    (clickCancel)='resetField(EditorEditItem.FOLDER)'
    (clickEdit)='editField(EditorEditItem.FOLDER)'
    (clickSave)='saveField(EditorEditItem.FOLDER, $event)'
    *ngIf='folderButton && foldersNavigationData'
    [dataLabel]="'TITLE.SELECT_FOLDER' | translate"
    [data]='foldersNavigationData'
    [editorButton]='folderButton'
    [link]="link"
    [label]="'LABELS.FOLDER' | translate"
    [optional]='false'
    [value]='folderId'>
  </pt-editor-sidebar-navigation-data>

  <pt-editor-sidebar-navigation-data
    (clickCancel)='resetField(EditorEditItem.TREATMENT_CATEGORY)'
    (clickEdit)='editField(EditorEditItem.TREATMENT_CATEGORY)'
    (clickSave)='saveField(EditorEditItem.TREATMENT_CATEGORY, $event)'
    *ngIf='treatmentCategoryButton && treatmentCategoryNavigationData'
    [dataLabel]="'TITLE.SELECT_TREATMENT_CATEGORY' | translate"
    [data]='treatmentCategoryNavigationData'
    [editorButton]='treatmentCategoryButton'
    [label]="'LABELS.TREATMENT_CATEGORY' | translate"
    [optional]='true'
    [value]='treatmentCategoryId'>
  </pt-editor-sidebar-navigation-data>


  <pt-editor-sidebar-navigation-data
    (clickCancel)='resetField(EditorEditItem.DEPARTMENT)'
    (clickEdit)='editField(EditorEditItem.DEPARTMENT)'
    (clickSave)='saveField(EditorEditItem.DEPARTMENT, $event)'
    *ngIf='departmentButton && departmentNavigationData'
    [dataLabel]="'TITLE.SELECT_DEPARTMENT' | translate"
    [data]='departmentNavigationData'
    [editorButton]='departmentButton'
    [label]="'LABELS.DEPARTMENT' | translate"
    [optional]='true'
    [value]='departmentId'>
  </pt-editor-sidebar-navigation-data>

  <pt-editor-sidebar-navigation-data
    (clickCancel)='resetField(EditorEditItem.PROCESS_OWNER)'
    (clickEdit)='editField(EditorEditItem.PROCESS_OWNER)'
    (clickSave)='saveField(EditorEditItem.PROCESS_OWNER, $event)'
    *ngIf='processOwnerButton && processOwnerNavigationData'
    [dataLabel]="'TITLE.SELECT_PROCESS_OWNER' | translate"
    [data]='processOwnerNavigationData'
    [editorButton]='processOwnerButton'
    [label]="'LABELS.PROCESS_OWNER' | translate"
    [optional]='true'
    [value]='processOwnerId'>
  </pt-editor-sidebar-navigation-data>

  <pt-editor-list-card
    *ngIf="legalEntities?.length > 0"
    [title]='"LABELS.LEGAL_ENTITIES" | translate'
    [entities]="legalEntities"
    [entity]="'legalEntity'">
  </pt-editor-list-card>

  <pt-editor-sidebar-link *ngFor='let link of links' [link]='link'></pt-editor-sidebar-link>

  <ng-content select='[panelResult]'>

  </ng-content>

  <!--CHART------------------------------------------------------------->
  <ng-content select='[panelDetails]'>

  </ng-content>
  <!--END/CHART------------------------------------------------------------->

  <ng-content select='[panelGroup]'>

  </ng-content>


</ng-container>

